import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { translate } from "../translations";

function Hero() {
  const { language } = useLanguage();

  return (
    <section id="hero" className="hero-section">
      <div className="hero-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>
      <div className="hero-content">
        <div className="hero-badge">{translate("heroBadge", language)}</div>
        <div className="hero-logo-container">
          <img
            src="/assets/ygalaad_icon_transparent.svg"
            alt="YGALAAD"
            className="hero-logo-icon"
          />
          <h1 className="hero-title">
            <span className="gradient-text">
              <span className="gradient-text-y">Y</span>GALA
              <span className="gradient-text-accent">AD</span>
            </span>
          </h1>
        </div>
        <p className="hero-subtitle">{translate("heroSubtitle", language)}</p>
        <div className="hero-cta">
          <a href="#products" className="btn-primary">
            {translate("btnDiscover", language)}
          </a>
          <a href="#contact" className="btn-secondary">
            {translate("btnContact", language)}
          </a>
        </div>
      </div>
      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
